import * as TYPES from './types';
export default {
    [TYPES.SET_AGENT_INFO](state, payload) {
        state.agentInfo = { ...payload };
    }
};
